import { Reveal, Eyebrow } from "@/components/Reveal";
import { EXPERIENCES } from "@/data/content";

export default function Experiences() {
  return (
    <section id="experiences" data-testid="experiences-section" className="bg-cream py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <Reveal>
          <Eyebrow>Experiences</Eyebrow>
        </Reveal>
        <div className="mt-6 flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <Reveal delay={0.1}>
            <h2 className="max-w-xl text-4xl leading-[1.15] text-forest md:text-5xl">
              Journeys we love <span className="italic text-gold">to design.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="max-w-sm text-sm leading-relaxed text-forest-mist">
              Every Mirevaa journey begins with the feeling you are chasing. These are the ones we craft most often —
              each one shaped entirely around you.
            </p>
          </Reveal>
        </div>

        <div className="mt-16 grid grid-cols-1 gap-x-14 gap-y-16 md:grid-cols-2">
          {EXPERIENCES.map((e, i) => (
            <Reveal
              key={e.n}
              y={44}
              delay={(i % 2) * 0.1}
              className={i % 2 === 1 ? "md:translate-y-12" : ""}
            >
              <article data-testid={`experience-card-${e.n}`} className="group">
                <div className="relative overflow-hidden">
                  <img
                    src={e.image}
                    alt={e.title}
                    className="h-64 w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105 md:h-80"
                  />
                  <span className="absolute left-5 top-5 bg-ivory/90 px-3 py-1.5 font-display text-sm italic text-forest">
                    {e.n}
                  </span>
                </div>
                <div className="border-b border-forest/10 pb-8 pt-6">
                  <h3 className="font-display text-2xl text-forest md:text-3xl">{e.title}</h3>
                  <p className="mt-2 font-display text-lg italic text-gold">{e.line}</p>
                  <p className="mt-4 text-sm leading-relaxed text-forest-mist">{e.copy}</p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
